import { makeStyles, createStyles } from "@material-ui/core";

//A largura do bloco central, declarada uma vez e usada por quem precisa dela:
//o fundo, o conteudo e a barra de acoes. Assim as tres acompanham umas as
//outras por construcao, em vez de repetirem o mesmo numero.
const block = {
  width: "100%",
  maxWidth: "700px",
  margin: "0 auto",
};

const useStyles = makeStyles((theme) => {
  return createStyles({
    root: {
      ...block,
      height: "100%",
      background: theme.palette.background.default,
    },

    //O bloco com o recuo do texto: e o que a foto e as informacoes do filme
    //usam. O mesmo recuo que os dois Container do MUI somavam antes.
    page: {
      ...block,
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),

      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      },
    },

    //A barra de acoes ocupa o bloco inteiro: ela e a base do bloco, nao uma
    //linha de texto dentro dele, entao nao leva o recuo lateral.
    bottomBar: block,

    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100%",
      paddingBottom: "5.2rem",

      background: theme.palette.background.default,
    },

    topMenu: {
      position: "fixed",
      top: 0,
      zIndex: 5,

      //de ponta a ponta, sem acompanhar a coluna central: o logo fica na borda
      //esquerda e os icones na direita, por marginLeft auto em sideIcon
      left: 0,
      right: 0,
      padding: "1.7rem 2rem 1.5rem 2rem",

      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "inherit",
      boxShadow: "none",
    },

    logo: {
      height: "2.75rem",
      alignSelf: "flex-start",
    },
    sideIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      marginLeft: "auto",
      gap: "10px",
    },
    content: {
      marginTop: "6.25rem",
    },

    cover: {
      width: "100%",
    },

    movieInfo: {
      marginTop: "1rem",
    },

    movieTitle: {
      fontSize: "1.8rem",
      fontWeight: 700,
      fontStyle: "italic",
      fontFamily: "Barlow Condensed, sans-serif",
      textTransform: "uppercase",
      marginBottom: "-0.1rem",
    },

    original_title: {
      fontSize: "0.93rem",
      fontWeight: 400,
      fontFamily: "Barlow Condensed, sans-serif",
      textTransform: "uppercase",
      marginBottom: "-0.1rem",
    },

    year: {
      fontSize: "0.93rem",
      color: theme.palette.primary.main,
      fontWeight: 600,
      fontStyle: "italic",
      marginBottom: "-0.05rem",
    },

    duration: {
      marginBottom: "1rem",
    },

    synopsis: {
      lineHeight: "1.4rem",
    },

    synopsis2: {
      lineHeight: "1.4rem",
      display: "inline",
      fontWeight: 700,
    },

    platforms: { padding: "1rem 0" },

    cast: {
      display: "inline",
    },

    synopsisContainer: {
      padding: "1rem 0 0 0",
    },

    castNames: {
      fontWeight: 700,
      textTransform: "uppercase",
    },

    platform: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },

    tags: {
      padding: "1rem 0 0 0",
    },

    tag: {
      marginBottom: "8px",
      marginRight: "8px",
    },

    listEndContainer: {
      height: "calc(100vh - 5.5rem)",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: theme.palette.background.default,
    },

    listEndMessage: {
      color: theme.palette.text.primary,
      textTransform: "uppercase",
      textAlign: "center",
      fontFamily: "Barlow Condensed, sans-serif",
      marginTop: "5.5rem",
    },

    appBar: {
      top: "auto",
      bottom: 0,
      background: theme.palette.primary.main,
      zIndex: 5,
    },

    //a largura vem de page; aqui fica so a aparencia da barra
    bottomMenu: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      width: "100%",
      marginBottom: "0.5rem",
      background: theme.palette.background.default,
      borderRadius: "0 0 2rem 2rem",
    },

    menuDivider: {
      height: "3rem",
      alignSelf: "center",
    },
  });
});

export default useStyles;
